module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.header.massTranslate))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.labels.inputLanguage,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputLang),
      callback: function($$v) {
        _vm.inputLang = $$v
      },
      expression: "inputLang"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.labels.outputLanguage,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.outputLang),
      callback: function($$v) {
        _vm.outputLang = $$v
      },
      expression: "outputLang"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.overwriteOptions))])]), _vm._v(" "), _vm._l((_vm.scope), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs4": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "color": "primary",
        "label": item.name
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitTranslate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8838d296","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MassAllItemsLanguage.vue
// module id = 593
// module chunks = 21